module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00339.25e15c84.jpg";